import AdditionalOptions from './AdditionalOptions.js'
import ShipFrom from './Fields/ShipFrom.js'
import PackingList from './Fields/PackingList.js'
import {BillToNotify, NotifyNotice, ShipToNotify} from './Fields/Notify.js'
import SingleWeight from './Fields/SingleWeight.js'
import PackagingWeight from './Fields/PackagingWeight.js'
import SingleDimensions from './Fields/Dimensions/SingleDimensions.js'
import AttachCustomsInfo from './Fields/AttachCustomsInfo.js'
import SendEUProductIdentifiers from './Fields/SendEUProductIdentifiers.js'
import ReferenceNumber from './Fields/ReferenceNumber.js'
import DeliveryConfirmation from './Fields/DeliveryConfirmation.js'
import CertificateOrigin from './Fields/CertificateOrigin.js'
import SaturdayDelivery from './Fields/SaturdayDelivery.js'
import DirectDelivery from './Fields/UPS/DirectDelivery.js'
import AdditionalHandling from './Fields/UPS/AdditionalHandling.js'
import DeclaredValue from './Fields/DeclaredValue.js'
import ResidentialAddress from './Fields/ResidentialAddress.js'
import DryIceWeight from './Fields/DryIceWeight.js'
import ShipperRelease from './Fields/UPS/ShipperRelease.js'
import {Payor, PayorAccountNumber, PayorZipcode} from './Fields/Payor.js'
import {
  DutiesPayor,
  DutiesPayorAccountNumber,
  DutiesPayorZipcode,
} from './Fields/DutiesPayor.js'
import MailInnovations from './Fields/UPS/MailInnovations.js'
import USPSEndorsement from './Fields/UPS/USPSEndorsement.js'
import ReasonForExport, {
  ReasonForExportExplanation,
} from './Fields/ReasonForExport.js'
import CostCenter from './Fields/UPS/CostCenter.js'
import PackageBillType from './Fields/PackageBillType.js'
import AlternateReturnToAddress from './Fields/AlternateReturnToAddress.js'
import AttachHazmatInfo from './SingleLabelConfigForm/AttachHazmatInfo.js'
import TaxInfo from './Fields/TaxInfo.js'
import EnableNotifications from './Fields/EnableNotifications.js'
import CarrierPickup from './Fields/AmazonSFP/CarrierPickup.js'
import {
  IncludeImporterOfRecord,
  ImporterOfRecord,
} from './SingleLabelConfigForm/IncludeImporterOfRecord.js'
import PickupDateRange from './Fields/PickupDateRange.js'
import DangerousGoods from './Fields/DangerousGoods.js'
import ETDService from './Fields/FedEx/ETDService.js'
import HoldAtLocation from './Fields/HoldAtLocation.js'
import HoldForPickup from './Fields/Endicia/HoldForPickup.js'
import ServiceEndorsement from './Fields/ServiceEndorsement.js'
import NonstandardDay from './Fields/DHL/NonstandardDay.js'
import NonstandardContents from './Fields/DHL/NonstandardContents.js'
import FederalTaxID from './Fields/DHL/FederalTaxID.js'
import StateTaxID from './Fields/DHL/StateTaxID.js'
import SmartPostIndicia from './Fields/FedEx/SmartPostIndicia.js'
import SmartPostHub from './Fields/FedEx/SmartPostHub.js'
import AlcoholShipmentLicense from './Fields/AlcoholShipmentLicense.js'
import SignatureRequired from './Fields/DHL/SignatureRequired.js'
import IsDutiable from './Fields/DHL/IsDutiable.js'
import {
  ForeignTradeRegulation,
  ForeignTradeRegulationNotice,
  InternalTransactionNumber,
} from './Fields/DHL/ForeignTradeRegulation.js'
import ContentsType from './Fields/Endicia/ContentsType.js'
import NondeliveryOption from './Fields/NondeliveryOption.js'
import ServiceOption from './Fields/CanadaPost/ServiceOption.js'
import MailingZipCode from './Fields/MailingZipCode.js'
import DeliveryInstructions from './Fields/DeliveryInstructions.js'
import InvoiceNumber from './Fields/InvoiceNumber.js'
import PurchaseOrderNumber from './Fields/PurchaseOrderNumber.js'
import DepartmentNumber from './Fields/DepartmentNumber.js'
import InsuredValue from './Fields/InsuredValue.js'
import ReturnReason from './Fields/ReturnReason.js'
import DryIceRegulationSet from './Fields/DryIceRegulationSet.js'
import SubPackageType from './Fields/SubPackageType.js'
import PharmacyDelivery from './Fields/PharmacyDelivery.js'
import PriorityAlert from './Fields/PriorityAlert.js'
import LabelType from './Fields/LabelType.js'
import {useLabelConfigContext} from './LabelConfigContext.js'
import ETDPreshipmentDocs from './Fields/ETDPreshipmentDocs.js'
import AncillaryEndorsement from './Fields/AncillaryEndorsement.js'
import OneRate from './Fields/OneRate.js'
import B13AFilingOption from './Fields/B13AFilingOption.js'
import ExportComplianceStatement from './Fields/ExportComplianceStatement.js'
import ParcelCharacteristics from './Fields/ParcelCharacteristics.js'
import HasNonstandardCharacteristics from './Fields/HasNonstandardCharacteristics.js'
import {BatteryMaterial, BatteryPackaging} from './Fields/BatteryMaterial.js'
import IgnoreBadAddress from './Fields/IgnoreBadAddress.js'
import ShipDate from './Fields/ShipDate.js'
import PickupDate from './Fields/PickupDate.js'
import DangerousGoodsCode from './Fields/DangerousGoodsCode.js'
import InsuranceType, {InsuranceTypeNotice} from './Fields/InsuranceType.js'
import TermsOfSale from './Fields/TermsOfSale.js'
import IsHazmat from './Fields/IsHazmat.js'
import SenderType from './Fields/SenderType.js'
import ReceiverType from './Fields/ReceiverType.js'

export default function OldLabelConfigForm() {
  const {shipperType} = useLabelConfigContext()
  if (!shipperType) {
    return null
  }

  return (
    <div>
      <ul className="list list--shipping-options margin-bottom-15">
        <li className="list__item--no-style">
          <ul className="list flex flex-wrap flex-wrap-margin-10">
            <SingleWeight />
            <SingleDimensions />
          </ul>
        </li>
        <ShipFrom />
        <AlternateReturnToAddress />
        <PackingList />
        <ResidentialAddress />
      </ul>
      <AdditionalOptions>
        <ul className="list list--shipping-options">
          <li className="list__item--shipping-options">
            <ul className="list list--shipping-options flex flex-wrap flex-wrap-margin-15 flex-grow">
              <BillToNotify />
              <ShipToNotify />
              <NotifyNotice />
            </ul>
          </li>
          <AttachCustomsInfo />
          <AttachHazmatInfo />
          <TaxInfo />
          <IncludeImporterOfRecord />
          <ImporterOfRecord />
          <ETDPreshipmentDocs />

          {/* Checkboxes */}
          <li className="list__item--shipping-options">
            <ul className="list list--shipping-options flex flex-wrap flex-wrap-margin-15 flex-grow">
              <EnableNotifications />
              <CarrierPickup />
              <ETDService />
              <CertificateOrigin />
              <SaturdayDelivery />
              <HoldAtLocation />
              <HoldForPickup />
              <SignatureRequired />
              <IsDutiable />
              <ShipperRelease />
              <AdditionalHandling />
              <DirectDelivery />
              <PharmacyDelivery />
              <OneRate />
              <HasNonstandardCharacteristics />
              <IgnoreBadAddress />
              <IsHazmat />
              <SendEUProductIdentifiers />
            </ul>
          </li>

          {/* Date */}
          <ShipDate />
          <PickupDate />
          <PickupDateRange />

          {/* Weight */}
          <PackagingWeight />
          <DryIceWeight />
          <DryIceRegulationSet />

          {/* Currency */}
          <DeclaredValue />
          <InsuredValue />
          <InsuranceType />
          <InsuranceTypeNotice />

          {/* Selects */}
          <DangerousGoods />
          <DangerousGoodsCode />
          <DeliveryConfirmation />
          <ServiceEndorsement />
          <NonstandardDay />
          <NonstandardContents />
          <Payor />
          <PayorAccountNumber />
          <PayorZipcode />
          <DutiesPayor />
          <DutiesPayorAccountNumber />
          <DutiesPayorZipcode />
          <SmartPostIndicia />
          <SmartPostHub />
          <AncillaryEndorsement />
          <AlcoholShipmentLicense />
          <ForeignTradeRegulation />
          <ForeignTradeRegulationNotice />
          <InternalTransactionNumber />
          <ContentsType />
          <ReasonForExport />
          <ReasonForExportExplanation />
          <TermsOfSale />
          <NondeliveryOption />
          <ServiceOption />
          <PackageBillType />
          <SubPackageType />
          <SenderType />
          <ReceiverType />
          <B13AFilingOption />
          <ExportComplianceStatement />
          <LabelType />
          <PriorityAlert />
          <ParcelCharacteristics />
          <BatteryMaterial />
          <BatteryPackaging />

          {/* Text */}
          <FederalTaxID />
          <StateTaxID />
          <MailInnovations />
          <CostCenter />
          <USPSEndorsement />
          <MailingZipCode />
          <DeliveryInstructions />
          <InvoiceNumber />
          <PurchaseOrderNumber />
          <DepartmentNumber />
          <ReturnReason />
          <ReferenceNumber />
        </ul>
      </AdditionalOptions>
    </div>
  )
}
